const LOCALE = 'en-US';

// Returns a readable date (e.g. "Oct 22, 2023").
export const formatDate = (dateStr) => {
  const date = new Date(dateStr);

  return date.toLocaleDateString(LOCALE, {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
};
